import "normalize.css";

//ADDING SASS
//add your sass files easilt by starting them with an underscore inside the inc or parts folders
// You can also manually add a regular file to the front end bundle so you have access to all scss variables and classes
//adding a separate scss here will work, but you wont have access to scss variables or @use, or @extend
import "./sass/front-end-bunde.scss";

//js from src

// import "./js/core/events";
import "./js/core/objectfitFallback";
// import "./js/core/sidebar";
// import "./js/core/navigation";
// import "./js/core/panel-left"
import "./js/core/smooth-scroll";
import "./js/core/icons";
import "./js/core/responsive-iframe";
import "./js/core/video-modal";
// TODO: How to set the order
// import "./js/core/swiper-bundle.min";
// import "./js/core/bootstrap.bundle";

//add all underscored js files from inc and parts
import "../inc/core/_core.js";
import "../inc/scrollmagic/_scrollmagic.js";
import "./parts/global/_browser_update.js";
import "./parts/site-header/_site-header.js";
import "./blocks/cards-carousel-flip-2023-block/_cards-carousel-flip-2023-block.js";
import "./blocks/carousel-card-teacher-es/_carousel-card-teacher-es.js";
import "./blocks/faq-block/_faq-block.js";
import "./blocks/hero-carousel-block/_hero-carousel-block.js";
import "./blocks/image-cards-carousel-v1-block/_image-cards-carousel-v1-block.js";
import "./blocks/image-cards-carousel-v2-br-block/_image-cards-carousel-v2-br-block.js";
import "./blocks/latam-estudiar-ingles-tabs-2023-block/_latam-estudiar-ingles-tabs-2023-block.js";
import "./blocks/opinion-carousel-block/_opinion-carousel-block.js";
import "./blocks/opinion-lg-carousel-block/_opinion-lg-carousel-block.js";
import "./blocks/promo-banner-countdown-block/_promo-banner-countdown-block.js";
import "./blocks/promo-payment-method-logos-block/_promo-payment-method-logos-block.js";
import "./blocks/reasons-block/_reasons-block.js";
import "./blocks/reasons-bullets-block/_reasons-bullets-block.js";
import "./blocks/reasons-bullets-es/_reasons-bullets-es.js";
import "./blocks/reasons-bullets-v2-block/_reasons-bullets-v2-block.js";
import "./blocks/reasons-dynamic-block/_reasons-dynamic-block.js";
import "./blocks/recursos-gratuitos-carousel-social-media-cards-block/_recursos-gratuitos-carousel-social-media-cards-block.js";
import "./blocks/recursos-gratuitos-tabs-blog-posts-block/_recursos-gratuitos-tabs-blog-posts-block.js";
import "./blocks/recursos-gratuitos-tabs-blog-posts-br/_recursos-gratuitos-tabs-blog-posts-br.js";
import "./blocks/testimonials-carousel-block/_testimonials-carousel-block.js";
import "./blocks/video-carousel-block/_video-carousel-block.js";
